import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";

//covers the two seat allocation misconfigurations an operator can hit:
//"disabled"    -> the ticket has a seat class but the cinema has seat allocation off (blocks the sale)
//"noSeatClass" -> seat allocation is on but the ticket has no seat class (informational, ticket is still added)
const SeatAllocationNoticeModal = ({ notice, closeFunc }) => {
  const { t } = useTranslation(["Home", "Common"]);

  const variant = notice?.variant;
  const pricecard = notice?.pricecard;

  //the id is a guid and means nothing to an operator, so only show a name when the api gives one
  const seatClassName = pricecard?.seatClassName || pricecard?.seatClass;

  return (
    <Transition appear show={!!notice} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900 text-center"
                >
                  {t(`ticket.seat.allocation.${variant}.title`)}
                </Dialog.Title>

                <p className="text-center py-4">
                  {t(`ticket.seat.allocation.${variant}.subtitle`)}
                </p>
                {variant === "disabled" && seatClassName && (
                  <p className="text-center font-bold pb-4">
                    {t("ticket.seat.allocation.seatClass", {
                      seatClass: seatClassName,
                    })}
                  </p>
                )}
                {pricecard?.shortName && (
                  <p className="text-center text-sm text-gray-500 pb-2">
                    {pricecard.shortName}
                  </p>
                )}
                <div className="flex justify-center mt-3">
                  <button
                    type="button"
                    className="inline-flex mr-2 border justify-center rounded-md border-blue-900 bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={closeFunc}
                  >
                    {t("Common:button.close")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
export default SeatAllocationNoticeModal;
